module.exports = __webpack_public_path__ + "img/ms-icon-310x310.282fc3d.png";